import { render, staticRenderFns } from "./specialAdjustment.vue?vue&type=template&id=71c642fa&scoped=true&"
import script from "./specialAdjustment.vue?vue&type=script&lang=js&"
export * from "./specialAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c642fa",
  null
  
)

export default component.exports